<nz-modal
  [(nzVisible)]="showPopup"
  [nzTitle]="chartTitle"
  nzClosable="true"
  [nzFooter]="null"
  nzMaskClosable="false"
  [nzClassName]="'chart-popup'"
  (nzOnCancel)="handleCancel()"
  [nzBodyStyle]="styleObj"
  [nzWidth]="modalWidth"
  [nzContent]="chartCarousel"
>
</nz-modal>

<ng-template #chartTitle>
  <span
    >Charts | {{ chartType | titlecase }} |
    {{ chartSubTypeDisplay | titlecase }}</span
  >
</ng-template>
<ng-template #chartCarousel>
  <div class="chart-settings">
    <div class="display-section">
      <span
        class="ticker"
        [title]="defaultData.companyFullName"
        [innerHtml]="defaultData.companyFullName | textEllipsis: 50"
      ></span>
    </div>
    <div class="options-section">
      <label
        *ngIf="
          hasAccessToStockPrice &&
          (selectedValue === 'revision-daily' ||
            selectedValue === 'revision-monthly')
        "
        nz-checkbox
        [(ngModel)]="isStockPriceChecked"
        [ngClass]="{ 'ch-pop-checkbox--active': isStockPriceChecked }"
        >Stock Price (EOD)</label
      >
      <div class="mr-12" *ngIf="defaultData.showRevisionSourceList">
        <app-multi-select-dropdown
          [data]="defaultData.revisionSourceList"
          [title]="'charts'"
          (callback)="revisionSourceChange($event)"
        >
        </app-multi-select-dropdown>
      </div>
      <div class="mr-12" *ngIf="defaultData.showSurpriseSourceList">
        <app-multi-select-dropdown
          [data]="defaultData.surpriseSourceList"
          [title]="'charts'"
          (callback)="surpriseSourceChange($event)"
          (maxLimitViolation)="maxLimitViolated()"
        >
        </app-multi-select-dropdown>
      </div>

      <app-multi-select-dropdown
        [data]="defaultData.peersList"
        (callback)="peersChange($event)"
        *ngIf="defaultData.showPeersList"
      >
      </app-multi-select-dropdown>
      <nz-radio-group
        [(ngModel)]="periodSwitch"
        [nzSize]="'small'"
        (ngModelChange)="onChangePeriod()"
        *ngIf="selectedValue === 'revision-analysis'"
        class="period-switch"
      >
        <label nz-radio-button nzValue="Q">Quarter</label>
        <label nz-radio-button nzValue="Y">Year</label>
      </nz-radio-group>

      <button class="tab-button" (click)="plotSwitch()" *ngIf="displayDataSet">
        {{ plotType }}
      </button>
      <span class="chart-type-select">
        <nz-select
          [(ngModel)]="selectedValue"
          nzPlaceHolder="Choose"
          (ngModelChange)="onChartTypeChange()"
          [nzDropdownClassName]="'chart-type-dropdown'"
          id="selectChart"
          nzSize="small"
          nzOptionOverflowSize="15"
          nzOptionHeightPx="24"
        >
          <nz-option-group
            *ngFor="let chartName of sortedChartNames"
            [nzLabel]="chartName"
          >
            <nz-option
              *ngFor="let chartType of chartMap[chartName]"
              [nzValue]="chartType.value"
              [nzLabel]="chartType.label"
            >
            </nz-option>
          </nz-option-group>
        </nz-select>
      </span>
    </div>
  </div>
  <div *ngIf="displayDataSet">
    <div class="display-data">
      <span
        class="line-item"
        [title]="displayData.lineItemName"
        [innerHtml]="displayData.lineItemName | textEllipsis: 30"
      ></span>
      <span class="period">{{ displayPeriod || displayOtherPeriod }}</span>
      <span class="magnitude" *ngIf="displayData.magnitude"
        >&nbsp;(in {{ displayData.magnitude }})</span
      >
    </div>

    <div
      class="standard-deviation"
      *ngIf="selectedValue === 'distribution-analysis'"
    >
      <span *ngIf="displayData.consensusValue !== ''"
        >Consensus:&nbsp;{{ displayData.consensusValue }}</span
      >
      <span
        *ngIf="displayData.stdDev !== ''"
        class="std"
        style="padding-left: 12px"
        >Standard Deviation:&nbsp; {{ displayData.stdDev }}</span
      >
    </div>
  </div>
  <div
    class="ch-pop-stock-price-details"
    *ngIf="
      (selectedValue === 'revision-daily' ||
        selectedValue === 'revision-monthly') &&
      isStockPriceChecked &&
      plotType === 'Data' &&
      stockPriceData &&
      stockPriceData[selectedValue] &&
      stockPriceData[selectedValue]['stockprice'] &&
      stockPriceData[selectedValue]['stockprice'].length
    "
  >
    <div class="ch-pop-stock-price-details-item">
      Prev Close:&nbsp;<b>{{
        stockPriceData[selectedValue].prev_close || "-"
      }}</b>
    </div>
    <div class="ch-pop-stock-price-details-item">
      <div class="ch-pop-tooltip-wrapper">
        <va-icon
          nz-tooltip
          [nzTooltipOverlayStyle]="{
            marginLeft: '-12px'
          }"
          [nzTooltipTitle]="priceTooltip"
          nzTooltipPlacement="bottomLeft"
          size="small"
          name="info-circle"
          class="ch-pop-info-icon"
        ></va-icon>
        Past {{ selectedValue === "revision-monthly" ? 2 : 1 }} Year:&nbsp;<b
          *ngIf="stockPriceData[selectedValue].past_year_yoy !== ''"
          [ngClass]="[
            stockPriceData[selectedValue].past_year_yoy < 0
              ? 'color-red'
              : 'color-green'
          ]"
          >{{ stockPriceData[selectedValue].past_year_yoy }}%</b
        >
        <b *ngIf="stockPriceData[selectedValue].past_year_yoy === ''">-</b>
      </div>
      <ng-template #priceTooltip>
        <div class="ca-tooltip-content">
          <div>
            {{
              "VA provides simple price returns, which does not include dividends"
            }}
          </div>

          <br />

          <div *ngIf="stockPriceData[selectedValue].prev_close !== ''">
            {{ "Current Price: " + stockPriceData[selectedValue].prev_close }}
          </div>
          <div *ngIf="stockPriceData[selectedValue].prev_close === ''">
            {{ "Current Price: -" }}
          </div>
          <div>
            {{
              "Current Date: " + stockPriceData[selectedValue].last_date || "-"
            }}
          </div>

          <br />

          <div *ngIf="stockPriceData[selectedValue].year_back_price !== ''">
            {{
              "Previous Price: " + stockPriceData[selectedValue].year_back_price
            }}
          </div>
          <div *ngIf="stockPriceData[selectedValue].year_back_price === ''">
            {{ "Previous Price: -" }}
          </div>
          <div>
            {{
              "Previous Date: " +
                stockPriceData[selectedValue].year_back_date || "-"
            }}
          </div>
        </div>
      </ng-template>
    </div>
    <div class="ch-pop-stock-price-details-item">
      Date:&nbsp;<b>{{ stockPriceData[selectedValue].last_date }}</b>
    </div>
    <div
      class="ch-pop-stock-price-details-item"
      *ngIf="stockPriceData[selectedValue].ex_name"
    >
      <span class="color-arsenic">{{
        stockPriceData[selectedValue].ex_name
      }}</span>
    </div>
  </div>
  <div class="carousel-holder" (click)="setFocus($event)">
    <va-icon
      size="small"
      name="less-than"
      class="leftArrow"
      (click)="prevChart()"
    ></va-icon>

    <nz-carousel
      [nzEnableSwipe]="false"
      (nzBeforeChange)="resetPeriod($event)"
      (nzAfterChange)="carouselChange($event)"
    >
      <div nz-carousel-content *ngFor="let index of chartCarouselList">
        <div class="chart-holder" *ngIf="index.value === selectedValue">
          <app-chart-plotter
            [(dataToUse)]="dataToUse"
            [chartType]="selectedValue"
            [chartTypeDisplay]="chartSubTypeDisplay"
            (chartDataSet)="setDisplayData($event)"
            *ngIf="plotType === 'Data'"
            [isRevisionStockPriceSelected]="isStockPriceChecked"
            (chartStockPriceDataChange)="setPriceStockData($event)"
          ></app-chart-plotter>
          <app-chart-data-table
            [(dataToUse)]="tableData"
            [chartType]="selectedValue"
            (chartDataSet)="setDisplayData($event)"
            *ngIf="plotType === 'Chart'"
          ></app-chart-data-table>
        </div>
      </div>
    </nz-carousel>
    <va-icon
      size="small"
      name="greater-than"
      class="rightArrow"
      (click)="nextChart()"
    ></va-icon>
  </div>
  <div
    class="footnote"
    *ngIf="
      hasAccessToStockPrice &&
      isStockPriceChecked &&
      (selectedValue === 'revision-daily' ||
        selectedValue === 'revision-monthly') &&
      plotType === 'Data'
    "
  >
    Pricing data &#169; {{ currentYear }} FactSet Research Systems Inc. All
    rights reserved.
  </div>
</ng-template>
